import React from 'react';
import { FeaturePageLayout } from '../components/FeaturePageLayout';
import { UserPlus, FileText, Calendar, Key, CheckCircle, Clock } from 'lucide-react';
/*
  SEO SPECIFICATION:
  Title: AI Onboarding Agents — New Clients Fully Onboarded Automatically
  Meta Desc: MISTR handles the entire client onboarding sequence — intake, docs, setup, communication — automatically. No handholding. No repetitive setup calls.
  Primary KW: automated client onboarding AI
*/
export function OnboardingAgents() {
  return <FeaturePageLayout seoTitle="Onboarding Agents — Zero Touch Setup | MindStream.ing" seoDesc="MISTR handles the entire client onboarding sequence — intake, docs, setup, communication — automatically. No handholding. No repetitive setup calls." heroEyebrow="ONBOARDING AGENTS" heroTitle={<>
          Onboarding Without <span className="text-gradient" data-id="element-1853">The Work.</span>
        </>} heroDesc="MR handles the entire onboarding sequence — intake, docs, setup, communication — automatically." heroImage="https://cdn.magicpatterns.com/uploads/dWXrt9xNFh6bNpGwsjysP6/ChatGPT_Image_Mar_20,_2026,_02_15_39_PM.png" howItWorks={{
    title: 'How It Works',
    steps: [{
      title: 'Client Signs',
      desc: 'The moment a contract is signed, the onboarding sequence begins.'
    }, {
      title: 'MR Collects',
      desc: 'MR collects docs, sends welcome info, and schedules kickoff.'
    }, {
      title: 'Provision',
      desc: 'System access is granted and the first deliverable is tracked.'
    }]
  }} features={{
    cards: [{
      icon: <FileText size={24} data-id="element-1854" />,
      title: 'Auto Document Collection',
      desc: 'Chases clients for missing assets and forms without you lifting a finger.'
    }, {
      icon: <UserPlus size={24} data-id="element-1855" />,
      title: 'Welcome Sequences',
      desc: 'Sends perfectly timed, personalized welcome emails to set expectations.'
    }, {
      icon: <Calendar size={24} data-id="element-1856" />,
      title: 'Kickoff Scheduling',
      desc: 'Coordinates calendars and books the initial strategy call automatically.'
    }, {
      icon: <Key size={24} data-id="element-1857" />,
      title: 'System Access Provisioning',
      desc: 'Creates accounts in your tools and sends login details securely.'
    }, {
      icon: <CheckCircle size={24} data-id="element-1858" />,
      title: 'Progress Tracking',
      desc: 'Keeps you and the client updated on exactly where they are in the process.'
    }]
  }} firstClientCallout="First client fully automated: KRT Insurance" data-id="element-1852" />;
}